import * as React from 'react';
import { connect } from 'react-redux';
import { LoopConfigDialog } from '../components';
import {
    EModalType, ILoopConfig, IOutputValue, IOutput, OutputsHelper, getControlTypesFromService, QueryBuilderHelper,
    PropertyHelper, ModalHelper, ComponentHelper, IComponentType, IValidationResponse, EComponentTypes, IMoveHandler,
    clone, EOutputScope, ILoopConfigSummaryColumn
} from '../helpers';
import { VALIDATION_UNSAVED_LOOP_ERROR } from '../constants';
import { IDropdownOption } from 'office-ui-fabric-react';
import store from '../store/store';
import types from '../store/types';

declare var $;

class LoopConfigContainer extends React.Component<any, any> {

    updateDebounceId: number;

    closeDialog = (save?: boolean) => {

        if (save) {

            if (QueryBuilderHelper.canSaveQueryEditor()) {

                let { loopConfigState, cache } = this.props;

                let loopConfig: ILoopConfig = this.props.loopConfigState.loopConfig;
                let errorMessages: string[] = PropertyHelper.getErrorMessages(loopConfig.Properties, false);
                errorMessages = errorMessages.concat(OutputsHelper.getErrorMessagesForGlobalAndLoopOutputs(loopConfig.OutputValues, true))

                if (errorMessages.length) {

                    store.dispatch({
                        type: types.SET_MODAL_ERROR_MESSAGES,
                        errorMessages: errorMessages
                    });

                    //scroll to the top of the dialog so that the error message is visible
                    ModalHelper.scrollToErrorDisplay();

                }
                else {
                    let componentTypes: IComponentType[] = cache.componentTypes;
                    let loopComponentType = componentTypes.filter(t => t.ComponentTypeId === EComponentTypes.loop);
                    if (loopComponentType && loopComponentType.length) {

                        let outputValues: IOutputValue[] = loopConfig.OutputValues.map(o => {
                            return {
                                ...o,
                                componentId: loopConfig.componentId
                            };
                        });

                        ComponentHelper.validateLoopComponentProperties(loopComponentType[0].Name, loopConfig.componentId,
                            loopConfig.Properties, outputValues, null, loopConfig.summaryColumns).then(
                                (validationResponse: IValidationResponse) => {

                                    let errorMessages: string[] = validationResponse.errorMessages.map((e) => e.clientErrorMessage);
                                    let warningMessages: string[] = validationResponse.warningMessages.map((w) => w.clientErrorMessage)

                                    if (errorMessages.length || warningMessages.length) {
                                        store.dispatch({
                                            type: types.SET_MODAL_ERROR_MESSAGES,
                                            errorMessages: errorMessages
                                        });
                                        store.dispatch({
                                            type: types.SET_MODAL_WARNING_MESSAGES,
                                            warningMessages: warningMessages
                                        });
                                        ModalHelper.scrollToErrorDisplay();
                                    }
                                    else {
                                        store.dispatch({
                                            type: types.UPDATE_LOOP,
                                            componentId: loopConfig.componentId,
                                            outputValues: outputValues,
                                            properties: loopConfig.Properties,
                                            summaryColumns: loopConfig.summaryColumns
                                        });

                                        //close the modal
                                        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
                                    }
                                }
                            );

                    }

                }

            }
        }
        else {
            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }

    }

    updateLoopConfig = (loopConfig: ILoopConfig) => {

        if (this.updateDebounceId) {
            clearTimeout(this.updateDebounceId);
            this.updateDebounceId = null;
        }

        this.updateDebounceId = setTimeout(() => {
            store.dispatch({
                type: types.SET_LOOP_CONFIG,
                loopConfig: loopConfig
            });
            this.updateDebounceId = null;
        }, 200);

    }

    showPivotErrorMessage = () => {

        if ($(".ms-Pivot-link.is-selected").length) {
            let activePivotItem = $(".ms-Pivot-link.is-selected").find('.ms-Pivot-text').text();
            let errorMessage: string = '';

            switch (activePivotItem) {
                case 'Validation':
                    errorMessage = VALIDATION_UNSAVED_LOOP_ERROR
                    break;
                default:
                    errorMessage = 'Please ensure all query builder properties contain valid queries';
                    break;
            }

            store.dispatch({
                type: types.SET_MODAL_ERROR_MESSAGES,
                errorMessages: [errorMessage]
            });
            ModalHelper.scrollToErrorDisplay();

        }

    }

    outputsMoveHandler: IMoveHandler = {
        drag: (e, index: number) => {
            let loopConfig: ILoopConfig = this.props.loopConfigState.loopConfig;
            loopConfig.fromIndex = index;
            this.updateLoopConfig(loopConfig);
        },
        drop: (e, toIndex: number) => {

            e.preventDefault();

            let loopConfig: ILoopConfig = this.props.loopConfigState.loopConfig;

            if (toIndex === null) {
                loopConfig.fromIndex = null;
                loopConfig.overIndex = null;
                this.updateLoopConfig(loopConfig);
            }
            else {
                let output: IOutput = clone(loopConfig.OutputValues[loopConfig.fromIndex]);
                loopConfig.OutputValues.splice(loopConfig.fromIndex, 1);
                loopConfig.OutputValues.splice(toIndex, 0, output);
                loopConfig.fromIndex = null;
                loopConfig.overIndex = null;
                this.updateLoopConfig(loopConfig);
            }

        },
        allowDrop: (e, i: number) => {

            let loopConfig: ILoopConfig = this.props.loopConfigState.loopConfig;

            e.preventDefault();

            if (i !== loopConfig.overIndex) {
                loopConfig.overIndex = i;
                this.updateLoopConfig(loopConfig);
            }

        }
    };

    summaryMoveHandler: IMoveHandler = {
        drag: (e, index: number) => {

            let loopConfig: ILoopConfig = this.props.loopConfigState.loopConfig;
            loopConfig.fromIndex = index;
            this.updateLoopConfig(loopConfig);
        },
        drop: (e, toIndex: number) => {

            e.preventDefault();

            let loopConfig: ILoopConfig = this.props.loopConfigState.loopConfig;

            if (toIndex === null) {
                loopConfig.fromIndex = null;
                loopConfig.overIndex = null;
                this.updateLoopConfig(loopConfig);
            }
            else {
                let summaryColumn: ILoopConfigSummaryColumn = clone(loopConfig.summaryColumns[loopConfig.fromIndex]);
                loopConfig.summaryColumns.splice(loopConfig.fromIndex, 1);
                loopConfig.summaryColumns.splice(toIndex, 0, summaryColumn);
                loopConfig.fromIndex = null;
                loopConfig.overIndex = null;
                this.updateLoopConfig(loopConfig);
            }

        },
        allowDrop: (e, i: number) => {

            e.preventDefault();

            let loopConfig: ILoopConfig = this.props.loopConfigState.loopConfig;

            if (i !== loopConfig.overIndex) {
                loopConfig.overIndex = i;
                this.updateLoopConfig(loopConfig);
            }

        }
    };

    render() {

        let { loopConfigState, outputs, types, localLoopOutputs } = this.props;
        let { operators, operatorTypes } = this.props.cache;

        let outputOptions: IDropdownOption[] = OutputsHelper.getOutputDropdownOptions(outputs,
            loopConfigState.loopConfig.previousOutputBlocks);

        let localLoopOutputOptions: IDropdownOption[] = OutputsHelper.getOutputDropdownOptions(localLoopOutputs, null);

        return <LoopConfigDialog
            operators={operators}
            operatorTypes={operatorTypes}
            types={types}
            loopConfig={loopConfigState.loopConfig}
            closeDialog={this.closeDialog}
            updateLoopConfig={this.updateLoopConfig}
            outputOptions={outputOptions}
            localLoopOutputOptions={localLoopOutputOptions}
            outputsMoveHandler={this.outputsMoveHandler}
            summaryMoveHandler={this.summaryMoveHandler}
            showPivotErrorMessage={this.showPivotErrorMessage}
        />;

    }

}

let mapStateToProps = (store) => {

    let outputs: IOutputValue[] = OutputsHelper.combineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs, store.modalState.modal.parentLoopId);
    let localLoopOutputs: IOutputValue[] = store.outputsState.outputs.filter((o: IOutput) => o.LoopId === store.modalState.loopConfigState.loopConfig.componentId);

    let types: IDropdownOption[] = store.cacheState.outputTypes
        .map((output: IOutput) => {
            return { key: output.Type, text: output.Name };
        });

    return {
        loopConfigState: store.modalState.loopConfigState,
        cache: store.cacheState,
        types: types,
        outputs: outputs,
        localLoopOutputs: localLoopOutputs
    };

};

export default connect<any, any, any>(mapStateToProps)(LoopConfigContainer);



// WEBPACK FOOTER //
// ./source/ts/containers/loop-config.tsx